import { widthHeightSizeClasses } from "@/types/CommonVariants";
import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const listClasses = tv({
  base: [
    "List__root",
    "list-none",
    "py-2",
    "px-0",
    "relative",
    "w-full",
    "grid",
    "auto-cols-auto",
    "gap-2",
  ],
  variants: {
    column: {
      1: "grid-cols-1",
      2: "sm:grid-cols-2 grid-cols-1",
      3: "sm:grid-cols-3 grid-cols-1",
      4: "sm:grid-cols-4 grid-cols-1",
      5: "sm:grid-cols-5 grid-cols-1",
      6: "sm:grid-cols-6 grid-cols-1",
      7: "sm:grid-cols-7 grid-cols-1",
      8: "sm:grid-cols-8 grid-cols-1",
      9: "sm:grid-cols-9 grid-cols-1",
      10: "sm:grid-cols-10 grid-cols-1",
      11: "sm:grid-cols-11 grid-cols-1",
      12: "sm:grid-cols-12 grid-cols-1",
    },
  },
});

export const listItemClasses = tv({
  base: ["List__item", "flex", "gap-2"],
  variants: {},
});

export const listItemTextClasses = tv({
  base: ["List__item-text flex-1"],
  variants: {},
});

export const listItemIconClasses = tv({
  // extend: widthHeightSizeClasses,
  base: ["List__item-icon flex-grow-0"],
  variants: {},
  defaultVariants: {
    size: "medium",
  },
});

export const listItemHeadingClasses = tv({
  base: ["mb-1", "text-black-600"],
  variants: {},
  defaultVariants: {},
});

export type ListVariants = VariantProps<typeof listClasses>;

export type ListItemHeadingVariants = VariantProps<
  typeof listItemHeadingClasses
>;
export type ListItemVariants = VariantProps<typeof listItemClasses>;
export type ListItemIconVariants = VariantProps<typeof listItemIconClasses>;
export type ListItemTextVariants = VariantProps<typeof listItemTextClasses>;
